const notifyEventType = {
  NOTIFY_EVENT_CUSTOMER_FOLLOW: 'event/customer-follow',
  NOTIFY_EVENT_CUSTOMER_BLOCK: 'event/customer-block',
};

export default notifyEventType;
